import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../common/components/button/button.component';

@Component({
  selector: 'app-inactive-cat-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent],
  templateUrl: './inactive-cat-dialog.component.html',
  styleUrl: './inactive-cat-dialog.component.scss'
})
export class InactiveCatDialogComponent {

  categoryTitle: string = '';
  is_active: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InactiveCatDialogComponent>,
  ) {
    this.categoryTitle = data?.name;
    this.is_active = data?.is_active
  }

  cancelInactivateCategory() {
    this.dialogRef.close();
  }

  inactivateCategory() {
    // this.data.is_active = this.data.is_active;
    this.dialogRef.close(this.data);
  }
}
